import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'
import { setErrors } from '../common/errorsSlice'

import {
  ResponseGetRiskTimeline,
  ResponseGetRiskMembers,
  ResponseGetRiskTeams,
  RequestGetRiskTimeline,
} from '../../types/risk'
import { getRiskMembers, getRiskTeams, getRiskTimeline } from '../../apis/risk'

interface State {
  isLoading: boolean
  riskTimeline: ResponseGetRiskTimeline
  riskMembers: ResponseGetRiskMembers
  riskTeams: ResponseGetRiskTeams
}

const initialState: Partial<State> = {
  isLoading: true,
  riskTimeline: undefined,
  riskMembers: undefined,
  riskTeams: undefined,
}

const riskSlice = createSlice({
  name: 'risk',
  initialState,
  reducers: {
    requestStart: (state) => {
      state.isLoading = true
      return state
    },
    buildRiskTimeline: (state, action: PayloadAction<ResponseGetRiskTimeline>) => {
      state.isLoading = false
      state.riskTimeline = action.payload
      return state
    },
    buildRiskMembers: (state, action: PayloadAction<ResponseGetRiskMembers>) => {
      state.isLoading = false
      state.riskMembers = action.payload
      return state
    },
    buildRiskTeams: (state, action: PayloadAction<ResponseGetRiskTeams>) => {
      state.isLoading = false
      state.riskTeams = action.payload
      return state
    },
    resetState: (state) => {
      // eslint-disable-next-line no-param-reassign
      state = initialState
      return state
    },
  },
})

export const {
  requestStart,
  buildRiskTimeline,
  buildRiskMembers,
  buildRiskTeams,
  resetState,
} = riskSlice.actions

export const riskReducer = riskSlice.reducer

export const fetchRiskTimeline = (
  param: RequestGetRiskTimeline,
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getRiskTimeline(param)
    .then((result: ResponseGetRiskTimeline) => {
      dispatch(buildRiskTimeline(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchRiskMembers = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getRiskMembers()
    .then((result: ResponseGetRiskMembers) => {
      dispatch(buildRiskMembers(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}

export const fetchRiskTeams = (
): AppThunk => async (dispatch) => {
  dispatch(requestStart())
  getRiskTeams()
    .then((result: ResponseGetRiskTeams) => {
      dispatch(buildRiskTeams(result))
    })
    .catch((error) => {
      dispatch(setErrors(error))
    })
}
